import DataSourceUsageDto from "../../../dtos/datasourcemodule/DataSourceUsageDto";

class DeleteDataSourceResult {
    Deleted: boolean;
    UsageDetails: DataSourceUsageDto[];

    constructor(deleted: boolean, usageDetails: DataSourceUsageDto[]) {
        this.Deleted = deleted;
        this.UsageDetails = usageDetails;
    }
}

export default DeleteDataSourceResult;
